import classNames from 'classnames';
import React from 'react';

import { Button } from 'reactstrap';

const statusColorMapping = {
    Hired: 'btn-status-open',
    Hold: 'btn-status-hold',
    Closed: 'btn-status-closed',
    'Contact Pending': 'btn-status-conacted',
    Contacted: 'btn-status-conacted',
    'Consult Scheduled': 'btn-status-conacted',
    'Under Review': 'btn-status-conacted',
};

const LeadStatusBtn = ({ referral }) => {
    const getStatusName = (referral) => {
        if (referral.caseStatus === 'Pending') {
            return 'New';
        }

        if (referral.leadStatus === 'Hired') {
            return 'Open';
        }

        if (
            referral.leadStatus === 'Closed' &&
            referral.leadStatusDescription
        ) {
            return referral.leadStatusDescription;
        }
        return referral.leadStatus;
    };

    return (
        <Button
            size="sm"
            className={classNames(
                `status-btn  ${statusColorMapping[referral.leadStatus]}`,
            )}
        >
            {getStatusName(referral)}
        </Button>
    );
};

export default LeadStatusBtn;
